<div class="apply-rewards-container">
  <h2 class="title">Apply Rewards to an Invoice</h2>
  <p class="description">
    Apply your available reward points toward an eligible outstanding invoice. Visit the UPS Billing Center to view all outstanding invoices and pay any remaining balance.
  </p>

@if (isModalOpen && selectedInvoice) {
  <div class="modal-overlay">
    <div class="modal-card">
      <button class="modal-close-x" (click)="onCloseModal()">&times;</button>

      <!-- STEP 1: INPUT FORM -->
      @if (!isSubmitted) {
        <h1 class="modal-title">Apply Rewards to an Invoice</h1>
        <div class="title-underline"></div>

        <div class="details-box">
          <div class="details-row">
            <span class="label">Invoice Number</span>
            <span class="value">{{ selectedInvoice.invoiceNumber }}</span>
          </div>
          <div class="details-row">
            <span class="label">Invoice Date</span>
            <span class="value">{{ selectedInvoice.invoiceDate | date:'MM/dd/yyyy' }}</span>
          </div>
          <div class="details-row">
            <span class="label">Due Date</span>
            <span class="value">{{ selectedInvoice.invoiceDueDate | date:'MM/dd/yyyy' }}</span>
          </div>
          <div class="details-row">
            <span class="label">Outstanding Balance</span>
            <span class="value amount">{{ selectedInvoice.outStandingAmount | currency }}</span>
          </div>
          <div class="details-row">
            <span class="label">Total Invoice Amount</span>
            <span class="value amount">{{ selectedInvoice.invoiceAmount | currency }}</span>
          </div>
        </div>

        <div class="input-section">
          <label class="input-heading">How many reward points would you like to apply?</label>
          <span class="points-available">
            Available points: <strong>{{ totalRewardsBalance | number }}</strong> pts
          </span>
          
          <div class="input-wrapper" [class.input-error-border]="isPointsInputInvalid">
            <span class="field-label">*Rewards Points</span>
            <input 
              type="number" 
              class="points-input" 
              [(ngModel)]="enteredPoints" 
              name="rewardsPoints"
              min="0"
              [max]="totalRewardsBalance"
              (input)="onPointsInputChange($event)">
          </div>


          @if (isPointsInputInvalid && pointsErrorMessage) {
    <span class="error-text">
      ⚠️ {{ pointsErrorMessage }}
    </span>
  } @else {
    <span class="points-conversion-hint">
      Points Value (USD): {{ dynamicPointsUsdValue | currency }}
    </span>
  }
        </div>

        <div class="modal-actions-row">
          <button class="btn-cancel-reward" (click)="onCloseModal()">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" class="chevron-left">
              <path d="M15 19l-7-7 7-7" />
            </svg>
            Cancel
          </button>
          <button class="btn-submit-reward" [disabled]="isPointsInputInvalid" (click)="onSubmitRewardPayment()">
            Apply Reward 
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" class="arrow-icon">
              <path d="M9 5l7 7-7 7" />
            </svg>
          </button>
        </div>
      } 
      @else {
        <h1 class="modal-title success-heading">Rewards Applied Successfully!</h1>

        <div class="success-card">
          <div class="details-row">
            <span class="label">Invoice Number</span>
            <span class="value">{{ selectedInvoice.invoiceNumber }}</span>
          </div>
          <div class="details-row">
            <span class="label">Redemption Date</span>
            <span class="value">{{ redemptionDate | date:'MM/dd/yyyy' }}</span>
          </div>
          <div class="details-row">
            <span class="label">Rewards Applied</span>
            <span class="value bold-value">
              {{ appliedPointsSnapshot | number }} pts ({{ appliedUsdSnapshot | currency }})
            </span>
          </div>
        </div>

        <div class="info-alert-box">
          <svg class="info-icon" viewBox="0 0 24 24" fill="none" stroke="#105497" stroke-width="2">
            <circle cx="12" cy="12" r="10"/>
            <line x1="12" y1="8" x2="12" y2="8"/>
            <line x1="12" y1="12" x2="12" y2="16"/>
          </svg>
          <p>
            Please visit the Billing Center to view all outstanding invoices and pay any remaining balances.
            Invoice balances in the Billing Center may take up to 24 - 48 hours to reflect reward payments.
            Please refer to the 'My Points' > 'Points Redeemed' section for up-to-date transaction details.
          </p>
        </div>

        <div class="success-actions-row">
          <button class="btn-done" (click)="onCloseModal()">
            Done
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" class="arrow-icon">
              <path d="M9 5l7 7-7 7" />
            </svg>
          </button>
          <button class="btn-go-billing" (click)="onGoToBillingCenter()">
            Go to Billing Center
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" class="arrow-icon">
              <path d="M9 5l7 7-7 7" />
            </svg>
          </button>
        </div>
      }

    </div>
  </div>
  }

  <div class="invoice-table">
    
    <div class="table-header-grid">
      <div class="header-cell">Invoice Number</div>
      <div class="header-cell text-center">Invoice Date</div>
      <div class="header-cell text-center">Due Date</div>
      <div class="header-cell text-center">Amount</div>
      <div class="header-cell text-center">Rewards Activity</div>
    </div>

    <div class="table-body">
      @for (invoice of (invoices | slice:0:visibleInvoiceLimit); track invoice.invoiceNumber) {
        <div class="invoice-card-row">
          <div class="body-cell invoice-number">{{ invoice.invoiceNumber }}</div>
          <div class="body-cell text-center">{{ invoice.invoiceDate | date:'longDate' }}</div>
          <div class="body-cell text-center">{{ invoice.invoiceDueDate | date:'longDate' }}</div>
          
          <!-- <div class="body-cell text-center amount">{{ invoice.invoiceAmount }}</div> -->
<div class="body-cell text-center amount-cell">
  <span class="invoice-total">{{ invoice.outStandingAmount | currency }}</span>

  @if (invoice.walletInvoiceStatus === 'Pending' ) {
    <span class="applied-rewards-subtext">
      -{{ invoice.walletActivePoints | number }} pts ({{ invoice.walletActiveValue | currency }})
    </span>
  }
</div>
          
          <div class="body-cell text-center">
           @if (invoice.walletInvoiceStatus === 'Open') { 
            <button class="btn-action" (click)="onApplyRewards(invoice)">
              Apply Rewards
              <svg class="chevron-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
                <path d="M9 5l7 7-7 7" />
              </svg>
            </button>
          } @else if (invoice.walletInvoiceStatus === 'Pending') {
            <span class="status-pending">
             <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
  <path d="M10.8587 9.3301L13.4002 11.8716C13.5809 12.0523 13.6677 12.2548 13.6608 12.4791C13.6538 12.7034 13.5624 12.9036 13.3864 13.0797C13.2103 13.2557 13.0066 13.3436 12.7754 13.3436C12.5441 13.3436 12.3399 13.2551 12.1629 13.078L9.38849 10.3039C9.30918 10.2244 9.2462 10.1337 9.19953 10.0318C9.15286 9.92997 9.12953 9.81517 9.12953 9.6874V5.7499C9.12953 5.50753 9.21259 5.30281 9.3787 5.13573C9.54495 4.96878 9.74863 4.88531 9.98974 4.88531C10.2309 4.88531 10.436 4.96878 10.6052 5.13573C10.7742 5.30281 10.8587 5.50753 10.8587 5.7499V9.3301ZM12.4964 4.36448C12.1872 4.36448 11.9238 4.25642 11.706 4.04031C11.4884 3.8242 11.3795 3.56149 11.3795 3.25219C11.3795 2.94302 11.4876 2.67955 11.7037 2.46177C11.9198 2.24413 12.1825 2.13531 12.4918 2.13531C12.801 2.13531 13.0645 2.24337 13.2822 2.45948C13.4999 2.67559 13.6087 2.9383 13.6087 3.2476C13.6087 3.55677 13.5006 3.82024 13.2845 4.03802C13.0684 4.25566 12.8057 4.36448 12.4964 4.36448ZM12.4964 17.8645C12.1872 17.8645 11.9238 17.7564 11.706 17.5403C11.4884 17.3242 11.3795 17.0615 11.3795 16.7522C11.3795 16.443 11.4876 16.1795 11.7037 15.9618C11.9198 15.7441 12.1825 15.6353 12.4918 15.6353C12.801 15.6353 13.0645 15.7434 13.2822 15.9595C13.4999 16.1756 13.6087 16.4383 13.6087 16.7476C13.6087 17.0568 13.5006 17.3202 13.2845 17.538C13.0684 17.7557 12.8057 17.8645 12.4964 17.8645ZM15.9964 7.36448C15.6872 7.36448 15.4238 7.25642 15.206 7.04031C14.9884 6.8242 14.8795 6.56149 14.8795 6.25219C14.8795 5.94302 14.9876 5.67955 15.2037 5.46177C15.4198 5.24413 15.6825 5.13531 15.9918 5.13531C16.301 5.13531 16.5645 5.24337 16.7822 5.45948C16.9999 5.67559 17.1087 5.9383 17.1087 6.2476C17.1087 6.55677 17.0006 6.82024 16.7845 7.03802C16.5684 7.25566 16.3057 7.36448 15.9964 7.36448ZM15.9964 14.8645C15.6872 14.8645 15.4238 14.7564 15.206 14.5403C14.9884 14.3242 14.8795 14.0615 14.8795 13.7522C14.8795 13.443 14.9876 13.1795 15.2037 12.9618C15.4198 12.7441 15.6825 12.6353 15.9918 12.6353C16.301 12.6353 16.5645 12.7434 16.7822 12.9595C16.9999 13.1756 17.1087 13.4383 17.1087 13.7476C17.1087 14.0568 17.0006 14.3202 16.7845 14.538C16.5684 14.7557 16.3057 14.8645 15.9964 14.8645ZM16.9964 11.1145C16.6872 11.1145 16.4238 11.0064 16.206 10.7903C15.9884 10.5742 15.8795 10.3115 15.8795 10.0022C15.8795 9.69302 15.9876 9.42955 16.2037 9.21177C16.4198 8.99413 16.6825 8.88531 16.9918 8.88531C17.301 8.88531 17.5645 8.99337 17.7822 9.20948C17.9999 9.42559 18.1087 9.6883 18.1087 9.9976C18.1087 10.3068 18.0006 10.5702 17.7845 10.788C17.5684 11.0057 17.3057 11.1145 16.9964 11.1145ZM1.89453 9.9999C1.89453 7.90323 2.59023 6.09177 3.98161 4.56552C5.37314 3.03927 7.0846 2.16753 9.11599 1.95031C9.3521 1.92031 9.55745 1.9874 9.73203 2.15156C9.90675 2.31573 9.99412 2.51816 9.99412 2.75885C9.99412 2.98719 9.92842 3.18587 9.79703 3.3549C9.66578 3.52406 9.49127 3.62746 9.27349 3.6651C7.68057 3.83455 6.34071 4.52024 5.25391 5.72219C4.1671 6.92427 3.6237 8.35017 3.6237 9.9999C3.6237 11.6411 4.1671 13.0649 5.25391 14.2711C6.34071 15.4774 7.68057 16.1652 9.27349 16.3347C9.49127 16.3723 9.66578 16.4759 9.79703 16.6453C9.92842 16.8148 9.99412 17.0119 9.99412 17.2368C9.99412 17.4737 9.90675 17.6759 9.73203 17.8434C9.55745 18.0108 9.35266 18.0798 9.11766 18.0503C7.08668 17.8377 5.37509 16.9669 3.98286 15.438C2.59064 13.9093 1.89453 12.0966 1.89453 9.9999Z" fill="#105497"/>
</svg>
              PENDING
            </span>
              } @else {
            <span class="status-default">{{ invoice.walletInvoiceStatus }}</span>
            }
          </div>
        </div>
      } @empty {
        <div class="empty-invoices-container">
          <div class="empty-icon-wrapper">
            <!-- Receipt with Dollar Icon -->
            <svg class="empty-state-icon" viewBox="0 0 24 24" fill="none" stroke="#2563eb" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">
              <path d="M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1Z"/>
              <line x1="12" y1="7" x2="12" y2="17"/>
              <path d="M14.5 9.5a2.5 2.5 0 0 0-5 0c0 3 5 2 5 5a2.5 2.5 0 0 1-5 0"/>
            </svg>
          </div>
          <h3 class="empty-title">No UPS Rewards eligible outstanding invoices</h3>
          <p class="empty-description">
            When a new eligible invoice is issued, it will appear here for payment processing.
          </p>
        </div>
      }
    </div>
  </div> 

@if (hasMoreInvoices) {
  <div class="see-more-wrapper">
    <button class="btn-see-more" (click)="onSeeMore()">
      {{ isExpanded ? 'See Less' : 'See More' }}
      <svg 
        class="chevron-down-icon" 
        [class.icon-rotated]="isExpanded" 
        viewBox="0 0 24 24" 
        fill="none" 
        stroke="currentColor" 
        stroke-width="2.5">
        <path d="M19 9l-7 7-7-7" />
      </svg>
    </button>
  </div>
}

</div>